import clsx from "clsx"

import { faIcon } from "@utils/faIcon"

import { Icon, NavigationLink } from "@atoms"

import useBottomSheet from "@organisms/BottomSheet/BottomSheet.store"

import styles from "./BottomSheetItem.module.scss"
import { BottomSheetItemProps } from "./BottomSheetItem.types"

export function BottomSheetItemBase(props: BottomSheetItemProps) {
    const {
        icon,
        label,
        path,
        hasSubItems,
        onClick,
        isExpanded,
        isDisabled,
        isDangerous,
        className,
        isTabbable = true,
        isSelected = false,
        children = null,
    } = props

    return (
        <NavigationLink
            title={label}
            path={path}
            className={clsx(styles.base, className, {
                [styles.disabled]: isDisabled,
                [styles.expanded]: isExpanded,
                [styles.dangerous]: isDangerous,
                [styles.selected]: isSelected,
                [styles.clickable]: !!onClick || !!path,
            })}
            isTabbable={isTabbable}
            onClick={onClick}
        >
            {() => (
                <div className={styles.container}>
                    <div className={styles.iconAndText}>
                        {icon && (
                            <div className={styles.icon}>
                                <Icon icon={icon} size={20} container="fixedHeight" />
                            </div>
                        )}

                        <span className={styles.text}>{label}</span>
                    </div>

                    {children}

                    {hasSubItems && (
                        <div className={styles.chevronWrap}>
                            <Icon
                                icon={faIcon({ name: "angle-right", style: "regular" })}
                                size={14}
                                container="fixedHeight"
                                className={styles.chevron}
                            />
                        </div>
                    )}
                    {isSelected && (
                        <div className={styles.checkmarkWrap}>
                            <Icon
                                icon={faIcon({ name: "circle-check", style: "solid" })}
                                size={16}
                                className={styles.checkmark}
                            />
                        </div>
                    )}
                </div>
            )}
        </NavigationLink>
    )
}

export default function BottomSheetItem(props: BottomSheetItemProps) {
    const { isTabbable = true, ...rest } = props
    const { isOpen } = useBottomSheet()

    return <BottomSheetItemBase {...rest} isTabbable={isTabbable && isOpen} />
}
